import { memo } from "react";
import { LabLoader } from "./lab-loader";

export const PageLoader = memo(function PageLoader() {
  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-background"
      role="status"
      aria-label="Cargando página"
    >
      <LabLoader size="lg" text="Preparando..." />
    </div>
  );
});
